export default "__VITE_ASSET__d6U6aRBZ__"